import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    getResidentAgreement,
    initialState,
} from 'app/core/models/slice/doc/getResidentAgreement'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'getResidentAgreement',
    initialState,
    reducers: {
        clearOnGetResidentAgreement: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setOnGetResidentAgreement: (
            state,
            action: PayloadAction<getResidentAgreement>
        ) => {
            state = { ...action.payload }
        },
        // setLonCnslCnlnNo: (state, action: PayloadAction<string>) => {
        //     state.lonCnslCnlnNo = action.payload
        // },
        // setCsncsSrn: (state, action: PayloadAction<string>) => {
        //     state.csncsSrn = action.payload
        // },
        // setDbtoCsm: (state, action: PayloadAction<string>) => {
        //     state.dbtoCsm = action.payload
        // },
        // setNofcCosnTgtPdfKcd: (state, action: PayloadAction<string>) => {
        //     state.nofcCosnTgtPdfKcd = action.payload
        // },
        setCstmTs: (state, action: PayloadAction<string>) => {
            state.cstmTs = action.payload
        },
        setOnGetResidentAgreementObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (key1 === key) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearOnGetResidentAgreement,
    setOnGetResidentAgreement,
    // setLonCnslCnlnNo,
    // setCsncsSrn,
    // setDbtoCsm,
    // setNofcCosnTgtPdfKcd,
    setCstmTs,
    setOnGetResidentAgreementObArr,
} = slice.actions

export default slice.reducer
